import { IConfigsType } from '../../types'

const fwWingstopDeliveryDaySchedules: IConfigsType = {
  'fw_wingstop-prep-item-admin-users-fc268486': {
    '/:brand/delivery_day_schedules': {
      title: {
        type: 'title',
        title: 'Delivery Day Schedules',
      },
      deliveryDaySchedules: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['fwWingstopDeliveryDaySchedules'],
      },
    },
  },
}

export default fwWingstopDeliveryDaySchedules
